/* global System */

export default {
  FinanzierungsRechner: () =>
    System.import(/* webpackChunkName: "FinanzierungsRechner" */ './index'),
}
